import React, { Component } from "react";
import { Input } from "antd";
import "./TextBox.css";

class Textbox extends Component {
  constructor(props) {
    super(props);
    //console.log(props)
    this.state = {};
  }
  changes = (e) => {
    console.log("inside Table Box");
    return this.props.change(this.props.id, e.target.value);
  };

  render() {
    // console.log(this.props.id);
    return (
      <div
        style={{
          marginTop:
            this.props.id === "claimNumber"
              ? "-24px"
              : this.props.id === "billingProviderName"
              ? "-24px"
              : this.props.id === "patientName"
              ? "-24px"
              : this.props.id === "taxid"
              ? "-8px"
              : this.props.id === "renderingNPI"
              ? "-8px"
              : this.props.id === "providerName"
              ? "-24px"
              : this.props.id === "subscribeID"
              ? "-8px"
              : this.props.id === "patientName"
              ? "-8px"
              : this.props.id === "planCode"
              ? "8px"
              : this.props.id === "paidOn"
              ? "8px"
              : this.props.id === "totalNetPaymentAmt"
              ? "-24px"
              : this.props.id === "totalPaymentAmount"
              ? "-24px"
              : this.props.id === "claimStatus"
              ? "-24px"
              : this.props.id === "claimType"
              ? "-8px"
              : "0px",
          width: "80px",
          marginLeft: 
            this.props.id === "taxid"
              ? "4px" 
              : this.props.id === "renderingNPI"
              ? "4px"
              : this.props.id === "subscribeID"
              ? "4px"
              : this.props.id === "patientName"
              ? "4px"
              : this.props.id === "totalNetPaymentAmt"
              ? "5px"
              : this.props.id === "totalPaymentAmount"
              ? "5px"
              : this.props.id === "claimStatus"
              ? "4px"
              : this.props.id === "claimType"
              ? "4px"
              : "0px"
        }}
      >
        <Input
          type="text"
          id={this.props.id}
          size="small"
          onChange={this.changes}
          // value={this.props.setField}
          // placeholder={"Enter " + this.props.id}
          placeholder={"Enter"}
        />
        {/* <input type="text" id={this.props.id}   class="form-control" name="searchField" onChange={this.changes} placeholder={'Enter ' + this.props.id}/> */}
      </div>
    );
  }
}

export default Textbox;
